/* eslint-disable import/prefer-default-export */
import { useCallback } from 'react'

import { usePaginatedAssetsQuery } from '~generated/hooks'
import { FilterAssetsInput } from '~generated/types'

type UsePaginatedAssetsParams = {
  filter: FilterAssetsInput
}

export function usePaginatedAssets({ filter }: UsePaginatedAssetsParams) {
  const { loading, data, variables, fetchMore } = usePaginatedAssetsQuery({
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      filter,
      sort: {
        orderIndex: 1,
      },
      pagination: {
        page: 1,
        limit: 25,
      },
    },
  })

  const loadMore = useCallback(() => {
    const { page, totalPages } = data?.paginatedAssets || {}

    if (!loading && page < totalPages) {
      fetchMore({
        variables: {
          filter,
          pagination: {
            page: page + 1,
            limit: 25,
          },
        },
      })
    }
  }, [filter, data, loading, fetchMore])

  return {
    loading,
    data,
    variables,
    loadMore,
  }
}
